module.exports = __webpack_public_path__ + "static/media/ambience.e6bfad9a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/ambience.mp3
// module id = 85
// module chunks = 0